import { ThemeOptions } from "@mui/material";

export const muiListItemIcon: ThemeOptions["components"] = {
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 30,
      },
    },
  },
};
